// Canonical seniority taxonomy — single source of truth for every dropdown
// (Add/Edit Contact, workflow Condition node, Trigger audience filter, Apollo
// search). Values are the Apollo taxonomy in snake_case, which is also the
// canonical storage form in contacts.seniority_level.
//
// Keep in sync with backend/app/core/seniority.py (CANONICAL_SENIORITY_LEVELS).
export interface SeniorityOption {
  value: string
  label: string
}

export const SENIORITY_OPTIONS: SeniorityOption[] = [
  { value: 'intern', label: 'Intern' },
  { value: 'entry', label: 'Entry' },
  { value: 'senior', label: 'Senior' },
  { value: 'manager', label: 'Manager' },
  { value: 'head', label: 'Head' },
  { value: 'director', label: 'Director' },
  { value: 'vp', label: 'VP' },
  { value: 'c_suite', label: 'C-Suite' },
  { value: 'partner', label: 'Partner' },
  { value: 'owner', label: 'Owner' },
  { value: 'founder', label: 'Founder' },
]

// Display helper: canonical value -> label; unknown/legacy values render as-is.
export function seniorityLabel(value?: string | null): string {
  if (!value) return ''
  const match = SENIORITY_OPTIONS.find(o => o.value === value)
  return match ? match.label : value
}
